import { useState } from 'react';

import { LocationIcon } from '@assets/icons';
import SearchBarSearchInput from '@components/ui/search/SearchBarInput/SearchBarSearchInput/SearchBarSearchInput';
import CustomIcon from '@components/utils/CustomIcon/index';
import { SEARCH_LENGTH } from '@utils/utils';

import { HotelSearchWrapper } from './styled';
import { SearchResult } from '../components/SearchResult';
import { BookerSearchViewModel } from '../../BookerSearchViewModel';
import { DesktopHotelDrawerProps } from '../types';
import { validSearchArrayItems } from '../helpers';

const DesktopHotelSearchDrawer = ({
  placeholder,
  history,
  onClearClick,
  callBack,
  onRemoveItem,
  error,
  cyprus,
  handleChange,
  inputLocation,
  locations,
  searchTextError,
  handleLocationClicked,
  popularSearchItems,
  onPopularSearchItemSelected,
}: DesktopHotelDrawerProps) => {
  const [showPastSearch, setShowPastSearch] = useState(false);

  const showPastSearches =
    validSearchArrayItems(history) && inputLocation?.length === 0;

  const showPoplarSearches =
    validSearchArrayItems(popularSearchItems) && inputLocation?.length === 0;

  const showUserSearches =
    (inputLocation?.length ?? 0) >= SEARCH_LENGTH &&
    (locations?.length ?? 0) > 0;

  return (
    <>
      <HotelSearchWrapper cyprus={cyprus}>
        <SearchBarSearchInput
          label='Nereye Gideceksiniz?'
          inputProps={{
            value: inputLocation,
            placeholder,
            onChange: handleChange,
            onFocus: () => {
              setShowPastSearch(true);
            },
            inputMode: 'search',
          }}
          leftIcon={() => (
            <CustomIcon
              fontSize={28}
              paletteColor='coral'
              icon={LocationIcon}
            />
          )}
          popoverProps={{
            align: 'end',
          }}
          error={error}
          searchTextError={searchTextError}
          SearchResultListComponent={({ onChange }) => {
            return showPastSearches ||
              showUserSearches ||
              showPoplarSearches ? (
              <SearchResult
                onChange={(item: BookerSearchViewModel) => {
                  onChange(item.text);
                  handleLocationClicked(item);
                }}
                searchText={inputLocation || ''}
                inputLocation={inputLocation}
                data={locations || []}
                history={history}
                showPastSearch={showPastSearch}
                onClearClick={onClearClick}
                callBack={callBack}
                onRemoveItem={onRemoveItem}
                popularSearchItems={popularSearchItems}
                onPopularSearchItemSelected={onPopularSearchItemSelected}
              />
            ) : null;
          }}
        />
      </HotelSearchWrapper>
    </>
  );
};

export default DesktopHotelSearchDrawer;
